import React, { useEffect, useState } from 'react';
import { Alert, AlertType } from '../../../components/Alert';
import { appendQueryParam } from '../../../utils/url';
import { UserNotification } from '../../../entities/v1/UserNotification';
import { UserNotificationService } from '../../../services/v1/UserNotificationService';

interface PropTypes {
  handleClose: () => void;
}

export default function DisconnectedCalendarAlert(props: PropTypes) {
  const [userNotification, setUserNotification] =
    useState<UserNotification>(null);

  const reconnectUrl = appendQueryParam(
    '/account_settings/integrations',
    'state',
    window.location.href,
  );

  useEffect(() => {
    UserNotificationService.disconnectedCalendarNotification().then(
      setUserNotification,
    );
  }, []);

  const handleClose = async () => {
    try {
      await UserNotificationService.dismiss(userNotification.id);
    } catch (error) {
      console.error('Failed to update notification status:', error);
    } finally {
      props.handleClose;
    }
  };

  return (
    userNotification && (
      <Alert type={AlertType.Danger} clearable={true} onClose={handleClose}>
        {
          "Your calendar connection was lost. Scheduling features won't work until you "
        }
        <a
          href={reconnectUrl}
          target='_blank'
          className='text-info'
          rel='noreferrer'
        >
          reconnect
        </a>
        {'.'}
      </Alert>
    )
  );
}
